import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ControllerPage, SettingsPage } from './pages';

const SettingFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SettingsPage />} />
      <Route path="controller" element={<ControllerPage />} />
    </Routes>
  );
};

export default SettingFeature;